// src/providers/FirebaseProvider.tsx
"use client";

import { useEffect, useState } from "react";
import { firebaseApp } from "@/api/utils/firebase";

export function FirebaseProvider({ children }: { children: React.ReactNode }) {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (firebaseApp) {
      setIsInitialized(true);
    }
  }, []);

  if (!isInitialized) {
    return null; // or a loading spinner
  }

  return <>{children}</>;
}
